import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import TextField from '@mui/material/TextField';

import TauxReclamation from '../TauxReclamation';

import ClientSearch from 'components/Shared/ClientSearch';
import ClientContactSelect from 'components/Shared/ClientContactSelect';
import MessageDialog from 'components/Shared/MessageDialog';

import { CompteEtat, ReclamationQualificationDetailCodes } from 'constants.js';
import { TypeCodes } from 'constants.js';
import { CategorieCodes } from 'constants.js';
import { QualificationCodes } from 'constants.js';

import localStorageHelper from 'utils/localStorageHelper';
import { getMessageAutorisationRemboursementEnMagasin } from 'utils/clientHelper';

const styles = {
    flexContainer: {
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-between',
        alignItems: 'top'
    },
    row: {
        flexBasis: '100%',
        padding: 10
    },
    leftSide: {
        flexBasis: '40%',
        padding: 10
    },
    rightSide: {
        flexBasis: '60%',
        padding: 10
    }
};


const ContenuDialogClientFerme = "Ce compte est fermé, les retours volontaires et SAV ne sont pas autorisés. Se rapprocher de la comptabilité pour plus d'informations."


class ClientStep extends React.Component {

    componentDidMount() {
        // On détermine si on doit rendre accessible le bouton pour passer à l'étape suivante.
        const { reclamation, onNextStepValid } = this.props;

        const nextStepValid = reclamation.client.id > 0;

        onNextStepValid(nextStepValid);
    }

    handleChange = (event) => {
        const { reclamation, onChange } = this.props;

        let errors = [];
        if (reclamation === null ||
            reclamation.client === null ||
            reclamation.client.id <= 0) {
            errors.push({ key: ReclamationQualificationDetailCodes.Client, errorMsg: 'Client requis' });
        } else {
            errors.push({ key: ReclamationQualificationDetailCodes.Client, errorMsg: null });
        }

        onChange(event, errors);
    }

    handleChangeClient = (client) => {
        const { onChangeClient } = this.props;

        let errors = [];
        if (!client || !client.id) {
            errors.push({ key: ReclamationQualificationDetailCodes.Client, errorMsg: 'Client requis' });
        } else {
            errors.push({ key: ReclamationQualificationDetailCodes.Client, errorMsg: null });
        }

        onChangeClient(client, errors);
    }

    render() {
        const { classes, reclamation, validationErrors, namespace, onChangeClientContact, onClose } = this.props;

        let clientError = validationErrors.find(e => e.key === ReclamationQualificationDetailCodes.Client);

        // Sur une réclamation de type cession, on autorise que l'activité 95.
        // Sur une réclamation de type client, on autorise pas l'activité 95
        const activitesAutorisees = reclamation.type.code === TypeCodes.Cession ? ['95'] : null;
        const activitesExclues = reclamation.type.code === TypeCodes.Client ? ['95'] : null;

        let afficheTaux = false;
        if (reclamation.type.code === TypeCodes.Client || reclamation.type.code === TypeCodes.Interne) {

            if (reclamation.categorie.code === CategorieCodes.CommandePasArrivee && reclamation.qualification.code === QualificationCodes.AucunColis) {
                afficheTaux = true;
            }

            if (reclamation.categorie.code === CategorieCodes.DefautProduit && reclamation.qualification.code === QualificationCodes.DefautProduitPremiereUtilisation) {
                afficheTaux = true;
            }

            if (reclamation.categorie.code === CategorieCodes.ProblemeReception) {
                afficheTaux = true;
            }
        }

        let afficheTypeClient = false;
        let isUtilisateurMagasin = localStorageHelper.getUtilisateurMagasin();

        // Si Retour volontaire + utilisateur 'Magasin' alors on affiche le type du client
        if (reclamation.type.code === TypeCodes.Client && reclamation.categorie.code === CategorieCodes.DemandeRetourMarchandiseLivreeConforme && isUtilisateurMagasin) {
            afficheTypeClient = true;
        }

        let avertissementOuvert = false;
        if (reclamation && reclamation.client && reclamation.client.etat === CompteEtat.Ferme)
        {
            avertissementOuvert = true;
        }


        return (

            <>

                <MessageDialog
                    titre="Avertissement"
                    contenu={ContenuDialogClientFerme}
                    ouvert={avertissementOuvert}
                    init={avertissementOuvert}

                    texteNOK="Annuler"
                    texteOK="Poursuivre"

                    onNOK={onClose}

                />


                <div className={classes.flexContainer}>

                    <div className={classes.row}>
                        <TextField
                            multiline
                            fullWidth
                            name="commentaire"
                            label="Commentaire"
                            placeholder="Décrire le problème rencontré"
                            maxRows="3"
                            margin="normal"
                            onChange={this.handleChange}
                            value={reclamation.commentaire}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </div>

                    <div className={classes.leftSide}>
                        <ClientSearch
                            namespace={namespace}
                            error={clientError}
                            onChange={this.handleChangeClient}
                            isRequired
                            activitesAutorisees={activitesAutorisees}
                            activitesExclues={activitesExclues}
                            autoFocus
                            client={reclamation.client}
                        />

                        {afficheTaux && (<TauxReclamation client={reclamation.client} />)}

                        {afficheTypeClient && reclamation.client && reclamation.client.autorisationRemboursementEnMagasin !== undefined && reclamation.client.autorisationRemboursementEnMagasin !== null && (
                            <>
                                <p>{getMessageAutorisationRemboursementEnMagasin(reclamation.client.autorisationRemboursementEnMagasin)}</p>
                            </>
                        )}

                    </div>
                    <div className={classes.rightSide}>
                        <ClientContactSelect
                            onChangeClientContact={onChangeClientContact}
                            namespace={namespace}
                        />
                        <TextField
                            fullWidth
                            id="nom-suivi"
                            name="suiviNomContact"
                            label="Nom contact"
                            placeholder="Saisir un contact"
                            margin="normal"
                            onChange={this.handleChange}
                            value={reclamation.suiviNomContact}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                        <TextField
                            fullWidth
                            id="email-suivi"
                            name="suiviEmail"
                            label="E-mail"
                            placeholder="Saisir une adresse e-mail"
                            margin="normal"
                            onChange={this.handleChange}
                            value={reclamation.suiviEmail}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                        <TextField
                            fullWidth
                            id="telephone-mobile"
                            name="suiviTelephoneMobile"
                            label="Téléphone mobile"
                            placeholder="Saisir un numéro de téléphone mobile"
                            margin="normal"
                            onChange={this.handleChange}
                            value={reclamation.suiviTelephoneMobile}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </div>
                </div>

            </>
        );
    }
}

ClientStep.propTypes = {
    reclamation: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onChangeClient: PropTypes.func.isRequired,
    onChangeClientContact: PropTypes.func.isRequired,
    validationErrors: PropTypes.array.isRequired,
    onNextStepValid: PropTypes.func.isRequired,
    namespace: PropTypes.string.isRequired
};

export default withStyles(styles)(ClientStep);